import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { TagsComponent } from './tags.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    TagsComponent
  ],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    TranslateModule
  ],
  exports: [
    TagsComponent
  ]
})
export class TagsModule { }
